module.exports = __webpack_public_path__ + "img/sepgreen.f04acf39.svg";